import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

// Local API calls use the configured Angular proxy. Production and asset URLs
// continue to use the backend address from the environment configuration.
export const devApiProxyInterceptor: HttpInterceptorFn = (request, next) => {
  const apiRoot = environment.apiRoot.replace(/\/$/, '');
  const isLocalPreview = typeof location !== 'undefined' && ['localhost', '127.0.0.1', '[::1]', '::1'].includes(location.hostname);
  if (environment.production || !isLocalPreview || !apiRoot || !request.url.startsWith(apiRoot + '/')) {
    return next(request);
  }
  const relativeUrl = request.url.slice(apiRoot.length);
  if (!/^\/(api|StoreConnection)(\/|\?|$)/i.test(relativeUrl)) {
    return next(request);
  }
  return next(request.clone({ url: relativeUrl }));
};
